import GetRfqQuoteDetails from '../../../../../../client/src/rfq/src/viewmodel/GetRfqQuoteDetailsViewModel';
import { DesBaseRfqQuote } from '../utils/des-base-rfq-quote';

export default class DesGetRfqQuoteDetails extends DesBaseRfqQuote {

    constructor() {
        console.log('DesGetRfqQuoteDetails invoked');
        super(GetRfqQuoteDetails);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfqQuote.observedAttributes];
    }
}

if (!window.customElements.get('des-get-rfq-quote-details')) {
    window.customElements.define('des-get-rfq-quote-details', DesGetRfqQuoteDetails);
}
